import { TextProps } from '@rbilabs/universal-components';

import { ISanityTypographyBlock } from '@rbi-ctg/menu';
import { HeaderProps } from 'components/ui/header';

export enum HorizontalPosition {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export interface ITypographyBlockProps
  extends Omit<TextProps, 'variant'>,
    Omit<HeaderProps, 'variant' | 'title' | 'onCloseIconClick'> {
  content: ISanityTypographyBlock[];
  color?: string;
  horizontalPosition?: HorizontalPosition;
}

export interface IColorable {
  color: string;
}

export interface IHorizontalPositionable {
  horizontalPosition: HorizontalPosition;
}
